import Model from '../../framework/model.js';
import Utils from '../../framework/utils.js';
import Globals from '../../framework/globals.js';
import JobLocationModel from './job-location-model.js';

const defaults = {};

// MapLocationModel
// ================
//
// Model wrapper around location data from WP.

class MapLocationModel extends Model {
  constructor(data = {}) {
    data.region = JobLocationModel.resolveLocationRegion(data.region);
    let idParts = [data.region, data.city].filter(p => p);
    data.id = Utils.slugify(idParts.join(' '));
    super({data: data, defaults: defaults});
  }

  getDisplayName() {
    return this.get('displayName') ? this.get('displayName') : this.get('name');
  }

  getFullAddress() {
    return `${this.get('address')}, ${this.get('city')}, ${this.get('region')} ${this.get('postalCode')}, ${this.get('country')}`
  }

  toCSV() {
    return `"${this.get('name')}", ${this.get('address')}, ${this.get('city')}, ${this.get('region')}, ${this.get('postalCode')}, ${this.get('country')}, ${this.get('remote')}`;
  }

  toJobLocationModel() {
    return JobLocationModel.fromMapLocation(this)
  }
}

export default MapLocationModel;